import React, { Component } from "react"
import { Helmet } from "react-helmet"

import { Flex, Box } from "grid-styled"

import { Img, H2, P, Page, TextBlock } from "../styled-components"

import bilder from "../bilder/uber"

class Uber extends Component {
  render() {
    return (
      <Page>
        <Helmet>
          <title>Fotografie Anders: Über mich</title>
        </Helmet>
        <H2>Über mich</H2>
        <Flex flexWrap="wrap">
          <Box width={[1, 1 / 2]} pr={[0, 4]}>
            <TextBlock>
              <P>
                Fotografieren bedeutet für mich, nicht nur den richtigen Moment
                abzupassen, interessante Motive einzufangen oder technisch
                hochwertige Bilder zu produzieren. Fotografieren ist für mich
                vor allem eines &mdash; Leidenschaft.
              </P>

              <P>
                Bereits in meiner Jugend habe ich begonnen, fotografisch zu
                experimentieren. Seitdem hat mich die Begeisterung für das
                Fotografieren nicht mehr losgelassen: im Beruf als Fotograf, im
                Alltag und auf meinen Reisen.
              </P>
            </TextBlock>
          </Box>
          <Box width={[1, 1 / 2]} pl={[0, 4]}>
            <TextBlock>
              <P>
                Bis heute beschäftige ich mich intensiv mit den verschiedensten
                Formen und Techniken der Fotografie. Dadurch konnte ich mich
                fotografisch immer weiter entfalten und so auch ein Gespür für
                den besonderen Augenblick, für spannende Perspektiven und für
                das Außergewöhnliche entwickeln.
              </P>

              <P>
                Ich bin 1969 geboren und lebe mit meiner Familie in Köln, bin
                gerne unterwegs und reise durch die Welt, wann immer es geht.
                Vor allem aber bin ich sehr gerne unter Menschen und immer
                neugierig darauf, Neues zu entdecken und genau hinzusehen.
              </P>
            </TextBlock>
          </Box>
        </Flex>
        <Img
          data-sizes="100vw"
          srcSet={bilder[1].min}
          // src={bilder[1]["1200"]}
          data-srcset={bilder[1].srcset}
          className="lazyload blur-up"
          alt="Bild 01"
          width="100%"
        />
      </Page>
    )
  }
}

export default Uber



// WEBPACK FOOTER //
// ./src/pages/Uber.js